<div class="content-info">
  <div class="zf-doc-head">
    <div class="zf-doc-left">
      <button type="button" (click)="goBack()" class="zf-doc-back"><i class="bi bi-arrow-left"></i> Vendors</button>
      <div class="zf-doc-title-row"><h4 class="zf-doc-title">{{ isEdit ? "Edit" : "Add" }} Vendor</h4></div>
    </div>
    <div class="zf-doc-actions">
      <button type="button" class="btn btnsecondary" (click)="goBack()">
        Cancel
      </button>
      <button type="button" class="btn btnprimary" (click)="saveVendor()">
        {{ isEdit ? "Update" : "Create" }}
      </button>
    </div>
  </div>

  <div class="input-fileds">
    <form [formGroup]="vendorForm" novalidate>
      <!-- Section 1: Basic Info -->
      <div class="product-catg">
        <h2>Basic Info</h2>
        <div class="catg-fileds">
          <div class="row">
            <!-- Vendor Name -->
            <div class="col-md-3 form-group">
              <label>Name *</label>
              <input type="text" formControlName="name" class="form-control" [ngClass]="{
                  'is-invalid':
                    vendorForm.get('name')?.invalid &&
                    vendorForm.get('name')?.touched
                }" />
              @if ( vendorForm.get('name')?.invalid &&
              vendorForm.get('name')?.touched ) {
              <div class="invalid-feedback">
                Name is required (max 100 characters)
              </div>
              }
            </div>

            <!-- Vendor Code -->
            <div class="col-md-3 form-group">
              <label>Vendor Code *</label>
              <input type="text" formControlName="vendorCode" class="form-control" [ngClass]="{
                  'is-invalid':
                    vendorForm.get('vendorCode')?.invalid &&
                    vendorForm.get('vendorCode')?.touched
                }" />
              @if ( vendorForm.get('vendorCode')?.invalid &&
              vendorForm.get('vendorCode')?.touched ) {
              <div class="invalid-feedback">
                Vendor Code is required (max 10 characters)
              </div>
              }
            </div>

            <!-- Contact Person -->
            <div class="col-md-3 form-group">
              <label>Contact Person *</label>
              <input type="text" formControlName="contactPerson" class="form-control" [ngClass]="{
                  'is-invalid':
                    vendorForm.get('contactPerson')?.invalid &&
                    vendorForm.get('contactPerson')?.touched
                }" />
              @if ( vendorForm.get('contactPerson')?.invalid &&
              vendorForm.get('contactPerson')?.touched ) {
              <div class="invalid-feedback">
                Contact Person is required (max 50 characters)
              </div>
              }
            </div>

            <!-- Contact Phone -->
            <div class="col-md-3 form-group">
              <label>Contact Phone *</label>
              <input type="text" formControlName="contactPhone" class="form-control" [ngClass]="{
                  'is-invalid':
                    vendorForm.get('contactPhone')?.invalid &&
                    vendorForm.get('contactPhone')?.touched
                }" />
              @if ( vendorForm.get('contactPhone')?.invalid &&
              vendorForm.get('contactPhone')?.touched ) {
              <div class="invalid-feedback">
                Contact Phone is required (max 15 digits)
              </div>
              }
            </div>

            <!-- Contact Email -->
            <div class="col-md-3 form-group">
              <label>Contact Email *</label>
              <input type="email" formControlName="contactEmail" class="form-control" [ngClass]="{
                  'is-invalid':
                    vendorForm.get('contactEmail')?.invalid &&
                    vendorForm.get('contactEmail')?.touched
                }" />
              @if ( vendorForm.get('contactEmail')?.invalid &&
              vendorForm.get('contactEmail')?.touched ) {
              <div class="invalid-feedback">
                Enter valid email (max 100 characters)
              </div>
              }
            </div>

            <!-- Address -->
            <div class="col-md-3 form-group">
              <label>Address *</label>
              <textarea formControlName="address" class="form-control" [ngClass]="{
                  'is-invalid':
                    vendorForm.get('address')?.invalid &&
                    vendorForm.get('address')?.touched
                }"></textarea>
              @if ( vendorForm.get('address')?.invalid &&
              vendorForm.get('address')?.touched ) {
              <div class="invalid-feedback">
                Address is required (max 250 characters)
              </div>
              }
            </div>

            <!-- City -->
            <div class="col-md-3 form-group">
              <label>City *</label>
              <input type="text" formControlName="city" class="form-control" [ngClass]="{
                  'is-invalid':
                    vendorForm.get('city')?.invalid &&
                    vendorForm.get('city')?.touched
                }" />
              @if ( vendorForm.get('city')?.invalid &&
              vendorForm.get('city')?.touched ) {
              <div class="invalid-feedback">City is required</div>
              }
            </div>

            <!-- State -->
            <div class="col-md-3 form-group">
              <label>State *</label>
              <input type="text" formControlName="state" class="form-control" [ngClass]="{
                  'is-invalid':
                    vendorForm.get('state')?.invalid &&
                    vendorForm.get('state')?.touched
                }" />
              @if ( vendorForm.get('state')?.invalid &&
              vendorForm.get('state')?.touched ) {
              <div class="invalid-feedback">State is required</div>
              }
            </div>

            <!-- Pincode -->
            <div class="col-md-3 form-group">
              <label>Pincode *</label>
              <input type="text" formControlName="pincode" class="form-control" [ngClass]="{
                  'is-invalid':
                    vendorForm.get('pincode')?.invalid &&
                    vendorForm.get('pincode')?.touched
                }" />
              @if ( vendorForm.get('pincode')?.invalid &&
              vendorForm.get('pincode')?.touched ) {
              <div class="invalid-feedback">Enter valid 6-digit pincode</div>
              }
            </div>

            <!-- Country -->
            <div class="col-md-3 form-group">
              <label>Country *</label>
              <input type="text" formControlName="country" class="form-control" [ngClass]="{
                  'is-invalid':
                    vendorForm.get('country')?.invalid &&
                    vendorForm.get('country')?.touched
                }" />
              @if ( vendorForm.get('country')?.invalid &&
              vendorForm.get('country')?.touched ) {
              <div class="invalid-feedback">Country is required</div>
              }
            </div>

            <!-- Vendor Type -->
            <div class="col-md-3 form-group">
              <label>Vendor Type *</label>
              <select formControlName="vendorType" class="form-control" [ngClass]="{
                  'is-invalid':
                    vendorForm.get('vendorType')?.invalid &&
                    vendorForm.get('vendorType')?.touched
                }">
                <option value="" disabled selected>Select Vendor Type</option>
                <option value="Manufacturer">Manufacturer</option>
                <option value="Distributor">Distributor</option>
                <option value="Wholesaler">Wholesaler</option>
                <option value="Service Provider">Service Provider</option>
              </select>
              @if ( vendorForm.get('vendorType')?.invalid &&
              vendorForm.get('vendorType')?.touched ) {
              <div class="invalid-feedback">Vendor Type is required</div>
              }
            </div>

            <!-- Payment Terms -->
            <div class="col-md-3 form-group">
              <label>Payment Terms *</label>
              <input type="text" formControlName="paymentTerms" class="form-control" [ngClass]="{
                  'is-invalid':
                    vendorForm.get('paymentTerms')?.invalid &&
                    vendorForm.get('paymentTerms')?.touched
                }" />
              @if ( vendorForm.get('paymentTerms')?.invalid &&
              vendorForm.get('paymentTerms')?.touched ) {
              <div class="invalid-feedback">Payment Terms are required</div>
              }
            </div>

            <!-- Preferred Currency -->
            <div class="col-md-3 form-group">
              <label>Preferred Currency *</label>
              <input type="text" formControlName="preferredCurrency" class="form-control" value="INR" readonly
                [ngClass]="{
                  'is-invalid':
                    vendorForm.get('preferredCurrency')?.invalid &&
                    vendorForm.get('preferredCurrency')?.touched
                }" />
              @if ( vendorForm.get('preferredCurrency')?.invalid &&
              vendorForm.get('preferredCurrency')?.touched ) {
              <div class="invalid-feedback">Preferred Currency is required</div>
              }
            </div>

            <!-- Rating -->
            <div class="col-md-3 form-group">
              <label>Rating (1-5)</label>
              <input type="number" formControlName="rating" class="form-control" min="0" max="5" [ngClass]="{
                  'is-invalid':
                    vendorForm.get('rating')?.invalid &&
                    vendorForm.get('rating')?.touched
                }" />
              @if ( vendorForm.get('rating')?.invalid &&
              vendorForm.get('rating')?.touched ) {
              <div class="invalid-feedback">Rating must be 0-5</div>
              }
            </div>


          </div>
        </div>
      </div>

      <!-- Section: PO Details -->
      <div class="product-catg">
        <h2>PO Details</h2>
        <div class="catg-fileds">
          <div class="row">
            <div class="col-md-3 form-group">
              <label>Day of Week</label>
              <ng-select [items]="[
                  'SUNDAY',
                  'MONDAY',
                  'TUESDAY',
                  'WEDNESDAY',
                  'THURSDAY',
                  'FRIDAY',
                  'SATURDAY'
                ]" [multiple]="true" formControlName="dayOfWeek" placeholder="Select days" class="form-control"
                [ngClass]="{
                  'is-invalid':
                    vendorForm.get('dayOfWeek')?.invalid &&
                    vendorForm.get('dayOfWeek')?.touched
                }">
              </ng-select>
            </div>

            <div class="col-md-3 form-group">
              <label>Day of Month</label>
              <ng-select [items]="[
                  1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18,
                  19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31
                ]" [multiple]="true" formControlName="dayOfMonth" placeholder="Select dates" class="form-control"
                [ngClass]="{
                  'is-invalid':
                    vendorForm.get('dayOfMonth')?.invalid &&
                    vendorForm.get('dayOfMonth')?.touched
                }">
              </ng-select>
            </div>

            <div class="col-md-3 form-group">
              <label>Default Cost Price Basis</label>
              <select formControlName="costPriceIncludesGst" class="form-control">
                <option [ngValue]="false">Basic + GST extra (B2B)</option>
                <option [ngValue]="true">Inclusive of GST (CGST Rule 35)</option>
              </select>
              <small class="text-muted d-block mt-1">
                Auto-applied as default on new POs for this vendor.
              </small>
            </div>
          </div>
        </div>
      </div>

      <!-- Section 2: Compliance Info -->
      <div class="product-catg">
        <h2>Compliance Info</h2>
        <div class="catg-fileds">
          <div class="row">
            <!-- GSTIN -->
            <div class="col-md-3 form-group">
              <label>GSTIN *
                @if (gstinValid === true) {
                <span class="text-success ms-2"><i class="bi bi-check-circle-fill"></i> Valid GSTIN</span>
                } @if (gstinValid === false) {
                <span class="text-danger ms-2"><i class="bi bi-x-circle-fill"></i> Invalid GSTIN</span>
                }
              </label>
              <div class="input-group has-validation">
                <input type="text" formControlName="gstin" class="form-control" style="text-transform: uppercase"
                  [ngClass]="{
                    'is-invalid':
                      (vendorForm.get('gstin')?.invalid &&
                      vendorForm.get('gstin')?.touched) || gstinValid === false,
                    'is-valid': gstinValid === true
                  }" />
                <button class="btn btn-outline-primary" type="button"
                  [disabled]="vendorForm.get('gstin')?.invalid || validatingGstin" (click)="validateGstin()">
                  @if(validatingGstin){
                  <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                  } @else { Validate }
                </button>
                @if ( vendorForm.get('gstin')?.invalid &&
                vendorForm.get('gstin')?.touched ) {
                <div class="invalid-feedback">
                  @if(vendorForm.get('gstin')?.hasError('required')){ GSTIN is
                  required } @else if
                  (vendorForm.get('gstin')?.hasError('pattern')) { Invalid GSTIN
                  format (e.g. 29ABCDE1234F1Z5) }
                </div>
                }
              </div>
            </div>

            <!-- PAN Number -->
            <div class="col-md-3 form-group">
              <label>PAN Number *</label>
              <input type="text" formControlName="panNumber" class="form-control" [ngClass]="{
                  'is-invalid':
                    vendorForm.get('panNumber')?.invalid &&
                    vendorForm.get('panNumber')?.touched
                }" />
              @if ( vendorForm.get('panNumber')?.invalid &&
              vendorForm.get('panNumber')?.touched ) {
              <div class="invalid-feedback">
                PAN Number is required (max 10 characters)
              </div>
              }
            </div>

            <!-- Constitution -->
            <div class="col-md-3 form-group">
              <label>Constitution *</label>
              <select formControlName="constitution" class="form-control" [ngClass]="{
                  'is-invalid':
                    vendorForm.get('constitution')?.invalid &&
                    vendorForm.get('constitution')?.touched
                }">
                <option value="" disabled selected>Select Constitution</option>
                <option value="Proprietorship">Proprietorship</option>
                <option value="Partnership">Partnership</option>
                <option value="Private Limited">Private Limited</option>
                <option value="Public Limited">Public Limited</option>
                <option value="LLP">LLP</option>
              </select>
              @if ( vendorForm.get('constitution')?.invalid &&
              vendorForm.get('constitution')?.touched ) {
              <div class="invalid-feedback">Constitution is required</div>
              }
            </div>

            <div class="col-md-3 form-group">
              <label>CIN </label>
              <input type="text" formControlName="cin" class="form-control" />
            </div>

            <!-- MSME Toggle Switch -->
            <div class="col-md-3 form-group">
              <div class="d-flex align-items-center justify-content-between">
                <label class="form-label mb-0 me-2" for="msmeToggle">Is your business MSME registered</label>
                <div class="form-check form-switch d-flex align-items-center">
                  <input class="form-check-input" type="checkbox" formControlName="isMSME" id="msmeToggle" [ngClass]="{
                      'bg-success': vendorForm.get('isMSME')?.value
                    }" />
                  <span class="ms-2 fw-bold" [ngStyle]="{
                      color: vendorForm.get('isMSME')?.value ? 'green' : '#555'
                    }">
                    {{ vendorForm.get("isMSME")?.value ? "yes" : "No" }}
                  </span>
                </div>
              </div>
            </div>
            <div class="w-100"></div>

            <!-- MSME/Udyam Registration Type (conditional) -->
            @if (vendorForm.get('isMSME')?.value) {
            <div class="col-md-3 form-group">
              <label>MSME/Udyam Registration Type *</label>
              <select formControlName="msmeRegistrationType" class="form-control" [ngClass]="{
                  'is-invalid':
                    vendorForm.get('msmeRegistrationType')?.invalid &&
                    vendorForm.get('msmeRegistrationType')?.touched
                }">
                <option value="" disabled selected>
                  Select Registration Type
                </option>
                <option value="Micro">Micro</option>
                <option value="Small">Small</option>
                <option value="Medium">Medium</option>
              </select>
              @if ( vendorForm.get('msmeRegistrationType')?.invalid &&
              vendorForm.get('msmeRegistrationType')?.touched ) {
              <div class="invalid-feedback">
                MSME/Udyam Registration Type is required
              </div>
              }
            </div>
            }

            <!-- MSME/Udyam Registration Number (conditional) -->
            @if (vendorForm.get('isMSME')?.value) {
            <div class="col-md-3 form-group">
              <label>MSME/Udyam Registration Number *</label>
              <input type="text" formControlName="msmeRegistrationNumber" class="form-control"
                placeholder="Enter registration number" [ngClass]="{
                  'is-invalid':
                    vendorForm.get('msmeRegistrationNumber')?.invalid &&
                    vendorForm.get('msmeRegistrationNumber')?.touched
                }" />
              @if ( vendorForm.get('msmeRegistrationNumber')?.invalid &&
              vendorForm.get('msmeRegistrationNumber')?.touched ) {
              <div class="invalid-feedback">
                MSME/Udyam Registration Number is required
              </div>
              }
            </div>
            }
          </div>
        </div>
      </div>

      <!-- Section 3: Bank Details -->
      <div class="product-catg">
        <h2>Bank Details</h2>
        <div class="catg-fileds">
          <div class="row">
            <!-- Bank Account Name -->
            <div class="col-md-3 form-group">
              <label>Bank Account Name *</label>
              <input type="text" formControlName="bankAccountName" class="form-control" [ngClass]="{
                  'is-invalid':
                    vendorForm.get('bankAccountName')?.invalid &&
                    vendorForm.get('bankAccountName')?.touched
                }" />
              @if ( vendorForm.get('bankAccountName')?.invalid &&
              vendorForm.get('bankAccountName')?.touched ) {
              <div class="invalid-feedback">Bank Account Name is required</div>
              }
            </div>

            <!-- Bank Account Number -->
            <div class="col-md-3 form-group">
              <label>Bank Account Number *</label>
              <input type="text" formControlName="bankAccountNumber" class="form-control" [ngClass]="{
                  'is-invalid':
                    vendorForm.get('bankAccountNumber')?.invalid &&
                    vendorForm.get('bankAccountNumber')?.touched
                }" />
              @if ( vendorForm.get('bankAccountNumber')?.invalid &&
              vendorForm.get('bankAccountNumber')?.touched ) {
              <div class="invalid-feedback">
                Bank Account Number is required
              </div>
              }
            </div>

            <!-- IFSC -->
            <div class="col-md-3 form-group">
              <label>IFSC *</label>
              <input type="text" formControlName="ifsc" class="form-control" [ngClass]="{
                  'is-invalid':
                    vendorForm.get('ifsc')?.invalid &&
                    vendorForm.get('ifsc')?.touched
                }" />
              @if ( vendorForm.get('ifsc')?.invalid &&
              vendorForm.get('ifsc')?.touched ) {
              <div class="invalid-feedback">IFSC is required</div>
              }
            </div>
          </div>
        </div>
      </div>

      <div class="product-catg">
        <h2>Associated Manufacturer</h2>

        <div class="col-md-12 border p-3 rounded">
          <!-- Manufacturer Search Dropdown + Add Button -->
          <div class="form-group mb-3">
            <label class="form-label">Search & Select Manufacturer* </label>

            <div class="row g-2 align-items-center">
              <div class="col-md-4 col-6">
                <ng-select class="w-100" [items]="manufacturers" bindLabel="name" bindValue="id" [searchable]="true"
                  placeholder="Search & select manufacturer" formControlName="manufacturerIds"
                  [loading]="searchingManufacturers" [disabled]="searchingManufacturers"
                  (search)="onManufacturerSearchInput($event)">
                </ng-select>
              </div>

              <div class="col-md-1 col-2">
                <button type="button" class="btn btnprimary w-100" (click)="selectManufacturerFromControl()">
                  Add
                </button>
              </div>
            </div>

            @if ( vendorForm.get('manufacturerIds')?.errors &&
            vendorForm.get('manufacturerIds')?.touched &&
            selectedManufacturers.length === 0 ) {
            <div class="text-danger">
              @if (vendorForm.get('manufacturerIds')?.errors?.['required']) {
              <div>Manufacturer is required</div>
              }
            </div>
            }
          </div>

          <!-- List of Selected Manufacturers -->
          @if (selectedManufacturers.length > 0) {
          <div class="list-group mt-5">
            @for (manufacturer of selectedManufacturers; track manufacturer; let
            i = $index) {
            <div class="list-group-item d-flex justify-content-between align-items-center">
              <div>
                <strong>{{ manufacturer.name }}</strong>
              </div>
              <button type="button" class="btn btn-sm btn-danger" (click)="removeManufacturer(i)">
                <i class="bi bi-x"></i> Remove
              </button>
            </div>
            }
          </div>
          } @else {
          <p class="text-muted mt-5 mb-0">No manufacturers associated yet.</p>
          }
        </div>
      </div>
    </form>
  </div>
</div>